import { apiClient } from './api';
import type { SquadLeaderboard,StandingsLimit,PairHistory,PairResultFilter } from '../types/squadLeaderboard';
export async function getSquadLeaderboard(squadId: string, month: string | undefined, expectedUserId: number | string, signal?: AbortSignal, limit:StandingsLimit='5'): Promise<SquadLeaderboard> {
  const response = await apiClient.get<SquadLeaderboard>(`/api/v1/web/squads/${encodeURIComponent(squadId)}/leaderboard`, {
    params: {...(month ? (month === 'LAST_3_MONTHS' || month === 'ALL_TIME' ? { period: month } : { month }) : {}),...(limit!=='5'?{limit}:{})}, signal, headers: { 'X-TARK-Expected-User-Id': String(expectedUserId) },
  });
  return response.data;
}
export async function setLeaderboardVisibility(squadId: string, visible: boolean, expectedUserId: number | string): Promise<void> {
  await apiClient.put(`/api/v1/web/squads/${encodeURIComponent(squadId)}/leaderboard/visibility`, { visible }, {
    headers: { 'X-TARK-Expected-User-Id': String(expectedUserId) },
  });
}

export async function getSquadPairHistory(squadId:string,first:string,second:string,period:string|undefined,result:PairResultFilter,expectedUserId:number|string,signal?:AbortSignal,cursor?:string):Promise<PairHistory>{
 const response=await apiClient.get<PairHistory>(`/api/v1/web/squads/${encodeURIComponent(squadId)}/leaderboard/pairs/${encodeURIComponent(first)}/${encodeURIComponent(second)}`,{
  params:{...(period?(period==='ALL_TIME'||period==='LAST_3_MONTHS'?{period}:{month:period}):{}),result,...(cursor?{cursor}:{})},signal,headers:{'X-TARK-Expected-User-Id':String(expectedUserId)},
 });return response.data;
}
